import React from 'react';
import { Helmet } from 'react-helmet';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';

const TermsOfService = () => {
    useDocTitle('Terms of Service | Skyland Web');

    return (
        <>
            <Helmet>
                <title>Terms of Service | Skyland Web</title>
                <meta
                    name="description"
                    content="Terms of Service for Skyland Web, governing your use of skylandweb.com and our services."
                />
            </Helmet>

            <NavBar />

            <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 mt-8 text-gray-700">
                <h1 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">Terms of Service</h1>
                <p className="mb-6 text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>

                <p className="mb-6">
                    These Terms of Service ("Terms") govern your use of skylandweb.com (the "Site") operated by
                    Skyland Web ("we", "us", or "our"). By accessing or using the Site, you agree to be bound by
                    these Terms.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Use of the Site</h2>
                <p className="mb-6">
                    You agree to use the Site only for lawful purposes and in a way that does not infringe the
                    rights of, restrict, or inhibit anyone else's use of the Site.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Services</h2>
                <p className="mb-6">
                    Skyland Web provides web development, mobile app development, and related IT services as
                    described on this Site. Any engagement for paid services is subject to a separate agreement
                    between you and Skyland Web.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Intellectual Property</h2>
                <p className="mb-6">
                    All content on this Site, including text, graphics, logos, and images, is the property of
                    Skyland Web or its licensors and is protected by applicable intellectual property laws.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Third-Party Advertising</h2>
                <p className="mb-6">
                    This Site may display advertisements served by third parties, including Google AdSense. We are
                    not responsible for the content of third-party advertisements. See our{' '}
                    <a href="/privacy-policy" className="text-blue-700 underline hover:text-blue-900">
                        Privacy Policy
                    </a>{' '}
                    for details on how these ads work.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Limitation of Liability</h2>
                <p className="mb-6">
                    The Site and its content are provided "as is" without warranties of any kind. Skyland Web
                    shall not be liable for any damages arising from your use of the Site.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Changes to These Terms</h2>
                <p className="mb-6">
                    We may update these Terms from time to time. Continued use of the Site after changes are
                    posted constitutes acceptance of the revised Terms.
                </p>

                <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-3">Contact Us</h2>
                <p className="mb-6">
                    Questions about these Terms can be sent to{' '}
                    <a href="mailto:info@skylandweb.com" className="text-blue-700 underline hover:text-blue-900">
                        info@skylandweb.com
                    </a>{' '}
                    or through our{' '}
                    <a href="/contact" className="text-blue-700 underline hover:text-blue-900">
                        contact page
                    </a>
                    .
                </p>
            </div>

            <Footer />
        </>
    );
};

export default TermsOfService;
